import { FullWidthAnimateHeight } from './Collapsible.styles'
import type { CollapsibleProps } from './Collapsible.types'

export const Collapsible = ({
  isExpanded,
  hasFading,
  condition,
  children,
  height = 'auto',
}: CollapsibleProps): JSX.Element | React.ReactNode => {
  if (condition) {
    return (
      <FullWidthAnimateHeight
        $hasFading={hasFading}
        $isExpanded={isExpanded}
        animate={{ height }}
        transition={{ ease: 'easeInOut', duration: 0.4 }}
      >
        {children}
      </FullWidthAnimateHeight>
    )
  }

  return children
}
